import React, { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { ThemeProvider } from '../contexts/ThemeContext';

interface LayoutProps {
  children: ReactNode;
  title?: string;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <ThemeProvider defaultTheme='light' storageKey='digitalwave-theme'>
      <div className='flex flex-col min-h-screen bg-background text-foreground transition-colors duration-300'>
        <Header />
        <main className='grow'>
          <div className='animate-fade-in'>{children}</div>
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Layout;
